import PropTypes from "prop-types"
import React from "react"

import typeMatch from "./typeMatch"

const CruiseStopIcon = ({ stopType }) => {
  const iconClassNames = (stopType) => {
    return typeMatch(stopType, {
      reservation: () => "fa-solid fa-calendar-check text-lg text-teal-600",
      marina: () => "fa-kit fa-ship-store text-lg text-orange-600",
      location: () => "fa-solid fa-location-dot text-lg text-blue-600",
      note: () => "fa-solid fa-file-lines text-lg text-gray-600",
    })
  }

  return (
    <div className={`inline-flex items-center justify-center rounded-full`}>
      <i className={iconClassNames(stopType)} />
    </div>
  )
}

CruiseStopIcon.propTypes = {
  stopType: PropTypes.string.isRequired,
}

export default CruiseStopIcon
